import React, { useEffect, useState } from "react";
import Banner from "../../components/Home/Banner";
import { useScreenSize } from "../../components";
import { useNavigate } from "react-router-dom";
import Blog from "../../components/Home/Blog";
import TrendingNow from "../../components/Home/TrendingNow";
import HowTo from "../../components/Home/HowTo";
import WorkExchange from "../../components/Home/WorkExchange";
import Tendering from "../../components/Home/Tendering";
import ScrollDownIndicator from "../../components/common/ScrollDownIndicator";

const LandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    return () => {};
  }, []);

  const handleSeeMoreTrendingNowClick = () => {
    navigate("/art-designs/community-spaces");
  };

  const handleSeeMoreWorkExchangeClick = () => {
    navigate("/art-designs/work-exchanges");
  };

  const handleSeeMoreTenderingClick = () => {
    navigate("/tenderings");
  };

  const handleSeeMoreBlock = () => {
    navigate("/blogs");
  };
  return (
    <div className="landing-page">
      <Banner />
      <div className="landing-page__content">
        <TrendingNow onSeeMore={handleSeeMoreTrendingNowClick} />
        <Tendering onSeeMore={handleSeeMoreTenderingClick} />
        <WorkExchange onSeeMore={handleSeeMoreWorkExchangeClick} />
        <Blog onSeeMore={handleSeeMoreBlock} />
        <HowTo />
      </div>
    </div>
  );
};

LandingPage.propTypes = {};

export default LandingPage;
